import React, { useState, useEffect } from 'react';
import cn from 'classnames';
import { i18n } from 'utils/i18n';
import { uuid } from 'utils/dom';
import Button from 'components/Button';
import RegionTileContent from './RegionTileContent';
import { propTypes } from './RegionTilePropTypes';

const RegionTile = ({ tileImage, name, countrySet, mapImage, disabled, onToggle, expanded, index }) => {
  const { countries } = countrySet;

  const tabId = uuid();
  const [isExpanded, setIsExpanded] = useState(expanded);

  useEffect(() => {
    if (onToggle) {
      setIsExpanded(expanded);
    }
  }, [expanded, onToggle]);

  const handleToggle = (e) => {
    e.preventDefault();
    // If onToggle is set, let callback handle expanding states via prop
    if (onToggle) {
      onToggle({ index, tabId, isExpanded });
    } else {
      setIsExpanded((prev) => !prev);
    }
  };

  return (
    <div className={cn('region-tile', { disabled, expanded: isExpanded })}>
      <Button
        plain
        className='region-tile__toggler'
        id={tabId}
        aria-label={name}
        aria-expanded={isExpanded ? 'true' : 'false'}
        aria-controls={`${tabId}__drawer`}
        onClick={handleToggle}
      >
        <div className='region-tile__image'>
          <img src={tileImage} alt={name} />
        </div>
        <div className='region-tile__title-bar'>
          <h3>{name}</h3>
          <span className='region-tile__countries-count'>
            {i18n('countries_count', { 0: Object.keys(countries).length })}
          </span>
          <span className='region-tile__view-all'>
            <span className='text'>{i18n('view_all')}</span>
          </span>
          <span className='region-tile__hide-all'>
            <span className='text'>{i18n('hide_all')}</span>
          </span>
        </div>
      </Button>
      <div
        className={`region-tile__drawer`}
        id={`${tabId}__drawer`}
        aria-labelledby={tabId}
        role='region'
        hidden={!isExpanded}
      >
        <RegionTileContent {...countrySet} name={name} mapImage={mapImage} />
      </div>
    </div>
  );
};

RegionTile.propTypes = propTypes;

export default RegionTile;
